import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-finish-welcome-gift-step-modal',
  templateUrl: './finish-welcome-gift-step-modal.component.html'
})
export class FinishWelcomeGiftStepModalComponent {

  constructor(
    public activeModal: NgbActiveModal,
    private _router: Router
  ) { }

  public navigateToWelcomeGiftPage() {
    this.activeModal.dismiss();
    this._router.navigate(['/welcome-gift']);
  }

}
